import { EMPTY_FUNCTION } from '../../../../constants/common'
import { AIButtonTextGrey } from '../../../AIButton'
import { ICON_HEIGHT_16, IconChevron } from '../../../Icon'
import { getGretaAIChatExpandChevronDirection } from '../../GretaAIChat.utils.projects'

import * as styles from './GretaAIChatChatListSectionToggle.module.css'

function GretaAIChatChatListSectionToggle({
  isCollapsed = false,
  qaName,
  title,
  onToggle = EMPTY_FUNCTION,
}) {
  const chevronDirection = getGretaAIChatExpandChevronDirection(!isCollapsed)

  return (
    <AIButtonTextGrey
      afterIconProps={{
        Icon: IconChevron,
        height: ICON_HEIGHT_16,
        iconProps: { direction: chevronDirection },
      }}
      className={styles.toggle}
      qaName={qaName}
      text={title}
      onClick={onToggle}
    />
  )
}

export default GretaAIChatChatListSectionToggle
